<template lang="pug">
ModelBasic(:show-left="showForm" :status="status" :error-info="errorInfo"  @download="toDownloadPdf" :download="download", :downloadShow="false", :rightTitle="rightTitle" :downloadResource="false" :isCkd="true")
    template(slot="left-title")
        .form-title(:class="titleClass")
    template(slot="left-content")
        .form-container(v-loading="resetLoading" v-if="!result.report" style="flex-direction: row;width: 100vw;")
            .form-container-left
                el-form.left-form(ref="form" :model="model", v-if="model && model.parameters")
                    .el-form-model(v-for="(k, kIndex) in keys")
                        GroupTitle(:title="k" style="margin-bottom: 16px;")
                        .el-form-items
                            template(v-for="(item, index) in getParameters(k)",)
                                el-form-item(
                                    v-if="item.key_type !== 'left_eye' && item.key_type !== 'right_eye'",
                                    :key="`${item.name}_${item.key_type}`",
                                    :rules="rules[item.name] || { required: projectIsRequired, trigger: 'blur', message: $t('notEntered') }",
                                    :prop="'parameters.' + item.index + '.value'")
                                    .name {{item.display}}
                                        span(v-if="item.value_unit") （{{ item.value_unit }}）
                                    GroupTitle(v-if="item.data_type === 'title'" :title="item.title" :tip="item.tip")
                                    //input-radio
                                    el-radio-group.item(
                                        v-model="model.parameters[item.index].value",
                                        @input="save()"
                                        :disabled="status === 'executing'"
                                        v-else-if="item.ques_type === 'single_choice' && item.show_type === 'select'")
                                        el-radio.gzzoc-radio(
                                            v-for="(info, i) in item.options",
                                            :key='i',
                                            :label="info.value") {{info.show_name}}
                                    //select
                                    el-select.gzzoc-select.item(
                                        :disabled="status === 'executing'"
                                        v-model="model.parameters[item.index].value",
                                        v-else-if="item.ques_type === 'single_choice' && item.show_type === 'pull'")
                                        el-option(
                                            v-for="(info, i) in item.options",
                                            :key='i',
                                            :label="info.show_name",
                                            :value="info.value")
                                    //checkbox
                                    el-checkbox-group.item(
                                        v-model="model.parameters[item.index].value",
                                        :disabled="status === 'executing'"
                                        v-else-if="item.ques_type === 'multi_choice'")
                                        el-checkbox.gzzoc-checkbox(
                                            v-for="(info, i) in item.options",
                                            :key='i',
                                            :name="item.name",
                                            :label="info.value") {{info.show_name}}
                                    // date_select
                                    el-date-picker.gzzoc-input(
                                        type="date"
                                        :disabled="status === 'executing'"
                                        v-model="model.parameters[item.index].value"
                                        format="yyyy-MM-dd"
                                        value-format="yyyy-MM-dd"
                                        v-else-if="item.ques_type === 'date_select'")
                                    //completion
                                    el-input.gzzoc-input.gzzoc-input-number.item(
                                        type="number",
                                        :disabled="item.name === 'BMI' || status === 'executing'"
                                        clearable
                                        v-model="model.parameters[item.index].value",
                                        @mousewheel.native.prevent
                                        @blur="inputNumber(item)"
                                        v-else-if="item.ques_type === 'completion' && (item.data_type === 'number' || item.data_type === 'int' || item.data_type === 'float')",
                                        :placeholder="$t('gzzoc.numberPlease')")
                                    //default
                                    el-input.gzzoc-input(
                                        type="text",
                                        v-model="model.parameters[item.index].value",
                                        clearable
                                        :disabled="item.name === 'BMI' || status === 'executing'"
                                        @blur="save()"
                                        v-else,
                                        :placeholder="$t('gzzoc.contentPlease')")
                                    .el-form-item__error(v-if="item.errorMsg") {{ item.errorMsg }}
            .form-container-right
                GroupTitle(:title="$t('fundusPhotography')" :tip="titleClass==='cn'?$t('fundusPhotographyTip'):''" style="margin-bottom: 24px;")
                el-form.form(ref="eyeForm", :model="model", v-if="model && model.parameters")
                    template(v-for="(item, index) in model.parameters")
                        el-form-item(
                            v-if="(item.key_type === 'left_eye' || item.key_type === 'right_eye') && item.display"
                            :rules="rules[item.name]",
                            :key="`${item.name}_${item.key_type}`",
                            :prop="'parameters.' + index + '.value'")
                            .name(v-if="item.display") {{item.key_type==='left_eye'?`${$t('gzzoc.leftEyeTitle')}`:`${$t('gzzoc.rightEyeTitle')}`}}
                            //file
                            el-upload.gzzoc-upload.item(
                                v-model="item.value",
                                v-if="item.ques_type === 'file'",
                                action="/api/upl/s3/upload/big/file/unsafe",
                                :disabled="status === 'executing'"
                                :show-file-list="false",
                                :ref="item.name"
                                :before-upload="(file) => {return beforeImgUpload(file,item.name)}",
                                :on-success="(res,file,files) => {return uploadsucc(res,file,files,item.name)}",
                                :on-error="(res) => {return handleError(res, item.name)}",
                                :on-progress="() => {return handleProgress(item.name)}")
                                .file-content-wrapper
                                    el-button.upload-button(type="primary" :loading="loadingUploadBtn(item.name)") {{$t('gzzoc.upload')}}
                                    span.file-name(v-show="upload[item.name]") {{upload[item.name]}}
        .form-container(v-else)
            template(v-for="k in keys")
                GroupTitle(:title="k" style="margin-bottom: 16px;")
                el-form.result-form(ref="form" :model="model", v-if="model && model.parameters")
                    template(v-for="(item, index) in getParameters(k)",)
                        el-form-item(
                            v-if="item.key_type !== 'left_eye' && item.key_type !== 'right_eye'",
                            :key="`${item.name}_${item.key_type}`",
                            :rules="rules[item.name] || { required: projectIsRequired, trigger: 'blur', message: $t('notEntered') }",
                            :prop="'parameters.' + index + '.value'")
                            .name {{item.display}}
                            GroupTitle(v-if="item.data_type === 'title'" :title="item.title" :tip="item.tip")
                            .result {{item.value || $t('noData')}}
    template(slot="left-footer")
        .form-footer(v-if="!result.report")
            el-button.gzzoc-button-primary.submit-btn(type="primary", @click="submit", :disabled="status === 'executing'") {{$t('startAnalysis')}}
            el-button.gzzoc-button-secondary.reset-btn(type="primary" @click="save(true)") {{$t('save')}}
            el-button.gzzoc-button-secondary.reset-btn(type="primary" @click="reset(true)") {{$t('reset')}}
        .form-footer(v-else)
            el-button.gzzoc-button-primary.submit-btn(type="primary" @click="resetResult(true)") {{$t('return')}}
            el-button.gzzoc-button-primary.submit-btn(type="primary" @click="resetResult(false)") {{$t('reEnter')}}
    template(slot="right-content")
        .right-content
            .main
                .item(v-if="result.left_eye_image || result.right_eye_image")
                    .eye
                        img.eye-img(v-if="result.left_eye_image" :src="imgsrc(result.left_eye_image)")
                        img.eye-img(v-if="result.right_eye_image" :src="imgsrc(result.right_eye_image)")
                .item(v-for="item in result.report")
                    .result.illness-analyse
                        .title {{$t('pathologicalClassification')}}：
                        .detail
                            span.detail-item.has-big-font
                                span.item-result
                                    .item-result-item {{$t('IgAN')}}: {{item.IgAN_prob}}  
                                    .item-result-item {{$t('DN')}}: {{item.DN_prob}}  
                                    .item-result-item {{$t('ANS')}}: {{item.HN_prob}}  
                                    .item-result-item {{$t('MN')}}: {{item.MN_prob}}  
                                    .item-result-item {{$t('MCD')}}: {{item['MCD/FSGS_prob']}}  
                    .result.diagnose-advice(v-if="item.High_PSG_prob")
                        .title {{$t('glomerulosclerosisRatio')}}：
                        .detail
                            span.detail-item.has-big-font
                                span.item-result {{item.High_PSG_prob}}
                    .result.diagnose-advice(v-if="item.End_prob5")
                        .title {{$t('prognosticPredictionResults')}}
                        .title(style="margin-top: 8px ") {{$t('prognosticPredictionResults2')}}：
                        .detail
                            span.detail-item.has-big-font
                                span.item-result {{item.End_prob5}}
    template(slot="right-tips")
        .right-content-wrapper.form-container(v-if="isReport(get(result.report, '[0]'))")
            GroupTitle(:title="$t('applicationFeedback')" style="margin: 24px 0;")
            el-form.feedback-form(ref="feedbackForm" :model="feedbackForm" :rules="feedbackRules" :inline="true")
                el-form-item(prop="job_title")
                    .name {{$t('yourPosition')}}
                    el-radio-group(v-model="feedbackForm.job_title")
                        el-radio(label="低级") {{$t('junior')}}
                        el-radio(label="中级") {{$t('intermediate')}}
                        el-radio(label="高级") {{$t('senior')}}
                // el-form-item(prop="is_match_you")
                //     .name {{$t('feedpackFormItem1')}}
                //     el-radio-group(v-model="feedbackForm.is_match_you")
                //         el-radio(label="是") {{$t('yes')}}
                //         el-radio(label="否") {{$t('no')}}
                el-form-item(prop="has_result")
                    .name {{$t('feedpackFormItem2')}}
                    el-radio-group(v-model="feedbackForm.has_result" @input="handleHasResult")
                        el-radio(label="有") {{$t('yes2')}}
                        el-radio(label="无") {{$t('no2')}}
                el-form-item(v-if="feedbackForm.has_result === '有'" prop="has_result_text")
                    .name {{$t('feedpackFormItem6')}}
                    el-input.gzzoc-input(
                        v-model="feedbackForm.has_result_text"
                        :placeholder="$t('gzzoc.contentPlease2')"
                        maxlength="50")
                el-form-item(v-if="feedbackForm.has_result === '有'" prop="is_match_actual")
                    .name {{$t('feedpackFormItem3')}}
                    el-radio-group(v-model="feedbackForm.is_match_actual")
                        el-radio(label="是") {{$t('yes')}}
                        el-radio(label="否") {{$t('no')}} 
                el-form-item(v-if="feedbackForm.has_result === '无'" prop="sug_result")
                    .name {{$t('feedpackFormItem7')}}
                    el-input.gzzoc-input(
                        v-model="feedbackForm.sug_result"
                        :placeholder="$t('gzzoc.contentPlease2')"
                        maxlength="50")
                // el-form-item(prop="is_change_treatment")
                //     .name {{$t('feedpackFormItem4')}}
                //     el-radio-group(v-model="feedbackForm.is_change_treatment")
                //         el-radio(label="是") {{$t('yes')}}
                //         el-radio(label="否") {{$t('no')}}
                el-form-item(prop="is_change_follow_up")
                    .name {{$t('feedpackFormItem5')}}
                    el-radio-group(v-model="feedbackForm.is_change_follow_up")
                        el-radio(label="是") {{$t('yes')}}
                        el-radio(label="否") {{$t('no')}}
            el-button.gzzoc-button-primary.submit-btn(type="primary" @click="feedbackSumbit") {{$t('sumbit')}}
        .right-content-desc(v-if="status === 'success'") {{$t('CKDDes')}}
</template>

<script>
import _ from 'lodash';
import { languages, i18n } from "@/locale";
import Logo from 'components/logo';
import UserNav from 'components/user-nav';
import ModelBasic from './gzzoc-model-basic';
import GroupTitle from '../components/group-title';
import UtilMixins from '@/mixins/utils';
import GzzocModelMixin from './gzzoc-model-mixin';
import ls from '@/utils/local-storage';

export default {
    data () {
        return {
            languages: languages,
            get: _.get,
            resetLoading: false,
            rightTitle: i18n.t('ckd2Title'),
            loading: {
                executing: false,
            },
            lock: [],
            download: {
                loading: false,
                locked: false
            },
            modelData: {
                parameter_list: []
            },
            model: {
                parameters: [
                    {value: ''}
                ],
            },
            keys: [],
            feedbackForm: {
                job_title: null,
                is_match_you: null,
                has_result: null,
                is_match_actual: null,
                sug_result: null,
                has_result_text: null,
                is_change_treatment: null,
                is_change_follow_up: null,
            },
            feedbackRules: {
                job_title: { required: true, trigger: 'change', message: i18n.t('requiredField') },
                is_match_you: { required: true, trigger: 'change', message: i18n.t('requiredField') },
                has_result: { required: true, trigger: 'change', message: i18n.t('requiredField') },
                has_result_text: { required: true, trigger: 'input', message: i18n.t('requiredField') },
                is_match_actual: { required: true, trigger: 'change', message: i18n.t('requiredField') },
                sug_result: { required: true, trigger: 'input', message: i18n.t('requiredField') },
                is_change_treatment: { required: true, trigger: 'change', message: i18n.t('requiredField') },
                is_change_follow_up: { required: true, trigger: 'change', message: i18n.t('requiredField') },
            },
            projectIsRequired: false,
            status: 'not_start',
            errorInfo: '',
            result: {
                value: '',
                explain: '',
                left_eye_image: '',
                right_eye_image: '',
                report: null,
                // report: {result: '123'},
                // success、error
                status: ''
            },
            upload: {
                loading_eyelid_images: false,
                loading_nail_image: false,
                status: "",
                right_eye: "",
                left_eye: "",
                right_eye_image: "",
                left_eye_image: "",
            },
            otherRuleName: ['Weight', 'Height', 'BMI', 'Systolic pressure', 'Diastolic pressure', 'Primary hypertension', 'Renal hypertension', 'Diabetes', 'Gout', 'CAD', 'Stroke', 'Heart failure', 'CKD duration', 'Ophthalmic diseases', 'Tumor', 'Specific gravity', 'PH', 'Urine GLU', 'Urine protein', 'Urine RBC count', '24-Hour Urine Protein', 'WBC', 'HB', 'PLT', 'K', 'Na', 'CL', 'CO2', 'UREA', 'Crea', 'Blood GLU', 'Ca', 'UA', 'P', 'ALB', 'GLB', 'TC', 'TG', 'HDL-C', 'LDL-C', 'ANA', 'dsDNA', 'Serum IgA', 'Serum IgM', 'Serum IgG', 'C3', 'C4', 'Left renal length', 'Left renal width', 'Right renal length', 'Right renal width', 'Clear demarcation', 'Hyperechoic medulla'],
            imgs: [],
            date: "",
            feedbackResult: false,
        };
    },
    mixins: [UtilMixins, GzzocModelMixin],
    components: {
        Logo,
        UserNav,
        ModelBasic,
        GroupTitle
    },
    watch: {
        'model.parameters': {
            handler () {
                let projectIsRequired = false
                let errorMsg = false
                _.forEach(this.model.parameters, (item, index) => {
                    if(item.name === 'BMI') {
                        const w = this.model.parameters[index - 1].value
                        const h = parseFloat(this.model.parameters[index - 2].value/100)
                        item.value = (w && h) ? parseFloat((w / Math.pow(h, 2)).toFixed(2)) : '' // 体重、身高未知固定在BMI前两列
                    }
                    if(_.includes(this.otherRuleName, item.name) && item.value) {
                        projectIsRequired = true
                    }
                    if(item.errorMsg) errorMsg = true
                })
                this.projectIsRequired = projectIsRequired
                this.errorMsg = errorMsg
                this.$nextTick(() => {
                    if(!this.result.report)this.$refs.form.clearValidate();
                });
            },
            deep: true,
            immediate: true
        },
        'result.report': {
            handler (value) {
                this.$nextTick(() => {
                    let leftC = document.querySelector('.left-container')
                    let leftF = document.querySelector('.left-form')
                    if(leftC) {
                        if(value) {
                            leftC.style.width = '400px'
                            if(leftF)leftF.style.width = '400px'
                        } else {
                            leftC.style.width = `${window.screen.width - 80}px`
                            leftF.style.width = `${(window.screen.width - 80)*0.8}px`
                        }
                    }
                })
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        id () {
            return this.$route.params.id;
        },
        lang () {
            return _.find(languages, {lang: this.$i18n.locale}) || languages[0];
        },
        titleClass () {
            let cls = ls.get('lang');
            return {
                'cn': cls === 'zh-CN',
                'en': cls === 'en'
            };
        },
        showForm () {
            return _.get(this.model, 'parameters', []).length > 0;
        },
        rules () {
            return {
                name: [{ required: true, trigger: ['blur'], message: i18n.t('notEntered')}],
                inpaitient_no: [{ required: true, trigger: ['blur'], message: i18n.t('notEntered')}],
                gender: [{ required: true, trigger: ['blur'], message: i18n.t('notEntered')}],
                age: [
                    {
                        trigger: ['blur', 'change'],
                        validator (rules, value, callback) {
                            if (value === undefined || value === '' || isFinite(+value)) {
                                callback();
                            } else {
                                callback(new Error('　'));
                            }
                        },
                        message: i18n.t('message.number')
                    },
                    {
                        required: true,
                        trigger: ['blur'],
                        message: i18n.t('message.age')
                    }
                ],
            };
        }
    },
    mounted () {
        this.getData();
        this.$nextTick(() => {
            document.querySelector('.left-container').style.width = `${window.screen.width - 80}px`
            document.querySelector('.left-form').style.width = `${(window.screen.width - 80)*0.8}px`
        })
    },
    destroyed () {
        clearTimeout(this.timer)
    },
    methods: {
        getParameters(key) {
            return _.filter(this.model.parameters, o=>o.ques_group===key)
        },
        // 数字输入口限制最大值最小值
        inputNumber(item) {
            const { data_type, value_range, value_decimal} = item
            let { value } = item
            if(value && value_range) {
                if(data_type==='float') {
                    item.value = (parseFloat(value * 100) / 100 ).toFixed(Number(value_decimal))
                    value = (parseFloat(value * 100) / 100 ).toFixed(Number(value_decimal))
                }
                if(data_type==='int') {
                    item.value = parseInt(Number(value))
                    // item.value = Math.round(Number(value))
                }
                if(Number(value) < value_range[0] || Number(value) > value_range[1]) {
                    item.errorMsg = `${this.$t('text1')}${value_range[0]}~${value_range[1]}`
                } else {
                    item.errorMsg = ''
                    this.save()
                }
            }
        },
        handleHasResult() {
            this.feedbackForm.has_result_text = ""
            this.feedbackForm.is_match_actual = ""
            this.feedbackForm.sug_result = ""
        },
        isReport(report) {
            const array = _.compact(_.values(report))
            return array.length
        },
        loadingUploadBtn (key) {
            return this.upload["loading_" + key];
        },
        resetResult(isNoReset) {
            if(!isNoReset && !this.feedbackResult) {
                this.$message({
                    message: this.$t('text2'),
                    type: 'warning'
                })
                return 
            }
            this.result = {
                value: '',
                explain: '',
                report: null,
                status: ''
            }
            this.status = 'not_start'
            this.feedbackForm =  {
                job_title: null,
                is_match_you: null,
                has_result: null,
                is_match_actual: null,
                has_result_text: null,
                sug_result: null,
                is_change_treatment: null,
                is_change_follow_up: null,
            }
            this.feedbackResult = false // 初始化反馈提交开关
            if(!isNoReset)this.reset()
        },
        reset (isDel) {
            if(!isDel) {
                this.clearData()
                return
            }
            this.resetLoading = true
            this.$http.get(`mli/predict_model/del_input_temp?model_id=${this.id}`).then(resp => {
                if (_.get(resp, 'body.value.code') !== 0) {
                    let errorInfo = _.get(resp, 'body.value.error');
                    this.$message.error(errorInfo);
                    return;
                }
                this.clearData()
                this.$message.success(this.$t('text7'))
            })
            .finally(() => {
                this.resetLoading = false
            })
        },
        clearData() {
            _.forEach(_.get(this, 'model.parameters', []), model => {
                switch (model.ques_type) {
                    case "single_choice": {
                        this.$set(model, 'value', model.default_value);
                        break;
                    }
                    case "multi_choice": {
                        this.$set(model, 'value', model.default_value);
                        break;
                    }
                    default: {
                        this.$set(model, 'value', '');
                        break;
                    }
                }
            });
            this.upload.right_eye = "";
            this.upload.right_eye_image = "";
            this.upload.left_eye = "";
            this.upload.left_eye_image = "";
            this.$nextTick(() => {
                if(!this.result.report)this.$refs.form.clearValidate();
            });
        },
        beforeImgUpload (file) {
            const types = ['image/jpeg', 'image/png', 'image/jpg'];
            const size = 5;

            const isJPG = (_.indexOf(types, file.type) > -1);
            const isLt2M = file.size / 1024 / 1024 < size;

            if (!isJPG) {
                this.$message.error(i18n.t('message.imgTypeUnknown'));
            } else if (!isLt2M) {
                this.$message.error(i18n.t('message.imgSizeExceed', { size }));
            }
            return isJPG && isLt2M;
        },
        uploadsucc (res, file, files, key) {
            const id = _.get(file, 'response.value[0]._id');
            const paramList = this.model.parameters;
            this.upload['loading_' + key] = false;
            if (id) {
                const i = _.findIndex(paramList, ['name', key]);
                if(!paramList[i].value) paramList[i].value = []
                paramList[i].value[0] = id
                this.upload[key] = file.name;
                this.upload.status = 'success';
                this.$message.success(i18n.t('message.imgUploadSuccess'));
                this.save()
            } else {
                this.upload.status = 'error';
                this.$message.error(i18n.t('message.imgUploadFail'));
            }
        },
        handleProgress (key) {
            this.upload.status = 'progress';
            this.upload['loading_' + key] = true;
        },
        handleError (res, key) {
            const errorInfo = JSON.parse(res.toString().replace('Error: ', ''));
            const errorMessage = _.get(errorInfo, '_error.detail', '');

            if (errorMessage) {
                this.$message.error(errorMessage);
            }

            this.upload.status = 'error';
            this.upload['loading_' + key] = false;
        },
        submit () {
            this.$refs.form.validate(result => {
                if (!result || this.errorMsg) {
                    this.$message.error(this.$t('pleaseCheckInput'));
                    return;
                } else if (!this.projectIsRequired && this.upload.left_eye_image === "" && this.upload.right_eye_image === "") {
                    this.$message.error(i18n.t('message.imgAtLeastAll'));
                    return;
                }
                this.status = 'executing';
                let parameters = this.getParameterValue();
                _.forEach(parameters.public, item=>{
                    if(!_.isNaN(Number(item.value))) {
                        item.value = Number(item.value)
                    }
                    if(item.name === 'Height') {
                        item.value = parseFloat(item.value/100)
                    }
                })
                this.$http.post('mli/predict_model/create_task', {
                    model_id: this.id,
                    parameters
                }).then(resp => {
                    if (_.get(resp, 'body.value.code') !== 0) {
                        let errorInfo = _.get(resp, 'body.value.error');
                        this.status = 'failed';
                        this.$message.error(errorInfo);
                        this.errorInfo = errorInfo;
                        return;
                    }
                    this.task_id = _.get(resp, 'body.value.data.task_id');
                    this.getResult(this.task_id);
                });
            });
        },
        getSaveParameterValue() {
            const parameters = this.model.parameters
            let object = {}
            _.forEach(parameters, item => {
                if(item.name === 'left_eye_image' || item.name === 'right_eye_image') {
                    object[item.name] = { value: item.value, name: this.upload[item.name] }
                } else {
                    object[item.name] = item.value
                }
                
            })
            return object
        },
        // 暂存
        save(isMsg) {
            if (isMsg && this.errorMsg) {
                this.$message.error(this.$t('text3'))
                return
            }
            const parameters = this.getSaveParameterValue();
            this.$http.post('mli/predict_model/save_input_temp', {
                model_id: this.id,
                input_data: parameters
            }).then(resp => {
                if (_.get(resp, 'body.value.code') !== 0) {
                    let errorInfo = _.get(resp, 'body.value.error');
                    this.$message.error(errorInfo);
                    return;
                }
                if(isMsg)this.$message.success(this.$t('text6'));
            });
        },
        getSaveParametes() {
            this.$http.get(`mli/predict_model/load_input_temp?model_id=${this.id}`).then(resp => {
                if (_.get(resp, 'body.value.code') !== 0) {
                    let errorInfo = _.get(resp, 'body.value.error');
                    this.$message.error(errorInfo);
                    return;
                }
                const data = _.get(resp, 'body.value.data')
                console.log(this.getKeyData(data))
                if(this.getKeyData(data)) {
                    this.$confirm(this.$t('text5'), this.$t('text4'), {
                        confirmButtonText: this.$t('confirm'),
                        cancelButtonText: this.$t('cancel'),
                        type: 'warning'
                    }).then(() => {
                        _.forEach(this.model.parameters, item => {
                            if(item.name === 'left_eye_image' || item.name === 'right_eye_image') {
                                this.upload[item.name] = data[item.name].name
                                item.value = data[item.name].value
                            } else {
                                item.value = data[item.name]
                            }
                        })
                    }).catch(() => {})
                }
            });
        },
        // 回填时候判断子项内容是否都有值
        getKeyData(data) {
            let result = false
            _.mapKeys(data, (value, key) => {
                if (key === 'left_eye_image' || key === 'right_eye_image') {
                    if (value.value) { 
                        result = true
                    }
                } else {
                    if (value) {
                        result = true
                    }
                }
            })
            return result
        },
        feedbackSumbit() {
            this.$refs.feedbackForm.validate(result => {
                if (!result) {
                    this.$message.error(this.$t('pleaseCheckInput'));
                    return;
                }
                this.$http.post('mli/predict_model/feedback_task', {
                    model_id: this.id,
                    task_id: this.task_id,
                    data: this.feedbackForm
                }).then(resp => {
                    if (_.get(resp, 'body.value.code') !== 0) {
                        let errorInfo = _.get(resp, 'body.value.error');
                        this.$message.error(errorInfo);
                        return;
                    }
                    this.$message.success(i18n.t('feedbackTip'));
                    this.feedbackResult = true
                });
            })
        },
        async getData () {
            this.model.parameters = [];
            await this.$http.get('mli/predict_model/model', {
                params: {
                    model_id: this.id
                }
            }).then(resp => {
                this.modelData = _.get(resp, 'body.value.data');
                this.model.parameters = this.formatParameters(this.modelData.parameters);
                this.model.parameters = _.map(this.model.parameters, (p, index) =>({...p, index, errorMsg: ''}))
                this.keys = _.compact(_.uniq(_.map(this.model.parameters, o=>o.ques_group)))
                this.getSaveParametes()
                this.reset();
            });
        },
        getResult (taskId) {
            if (!taskId) {
                this.status = 'not_start';
                return;
            }
            clearTimeout(this.timer);
            this.$http.get('/api/mli/predict_model/task_result', {
                params: {
                    task_id: Array.isArray(taskId) ? taskId.join('|') : taskId
                }
            }).then(resp => {
                if (_.get(resp, 'body.value.code') !== 0) {
                    let errorInfo = _.get(resp, 'body.value.error');
                    this.status = 'failed';
                    this.$message.error(errorInfo);
                    this.errorInfo = errorInfo;
                    return;
                }
                const status = _.get(resp, 'body.value.data.status');
                if (status === 'failed') {
                    let errorInfo = _.get(resp, 'body.value.data.error_info[0]', this.$t('gzzoc.execFailed'));
                    this.status = 'failed';
                    this.$message({
                        type: 'error',
                        showClose: true,
                        duration: 0,
                        message: errorInfo
                    })
                    this.errorInfo = errorInfo;
                    return;
                } else if (status === 'completed') {
                    const result = _.get(resp, 'body.value.data.results', {});
                    if (result.report[0].status === 0) {
                        let errorInfo = _.get(result.report[0], 'errors');
                        this.status = 'failed';
                        this.$message.error(errorInfo);
                        this.errorInfo = errorInfo;
                    } else {
                        this.result = result;
                        this.status = 'success';
                    }
                    return;
                }
                this.timer = setTimeout(() => {
                    this.getResult(taskId);
                }, 3000);
            });
        },
        toDownloadPdf () {
            let taskId = Array.isArray(this.task_id) ? this.task_id.join('|') : this.task_id;
            this.downloadPdf(taskId, "dprint", this.date, this.download);
        }
    }
};
</script>

<style lang="sass" scoped>
::v-deep
    .left-container
        z-index: 2
        .left-form
            display: flex
            flex-direction: column
            .el-form-model
                display: flex
                flex-direction: column
                &:not(:first-child)
                    margin-top: 16px
            .el-form-items
                display: flex
                flex-wrap: wrap
                overflow: auto
                background-color: #e9ecf1
                padding: 16px
                border-radius: 10px
            .el-form-item
                width: 240px
                margin-right: 40px
    .right-container
        justify-content: inherit
        gap: 16px
        .right-content-wrapper
            .header
                .title
                    font-family: '微软雅黑'
                    color: #002060
.feedback-form
    ::v-deep
        .el-form-item
            margin-right: 40px
            .name
                color: #333
                font-feature-settings: 'clig' off, 'liga' off
                font-family: "PingFang SC"
                font-size: 16px
                font-style: normal
                font-weight: 600
                line-height: 22px
.form-title
    width: 100%
    height: 48px
    margin-top: 24px
    background-repeat: no-repeat
    &.cn
        background-image: url(~public/images/gzzoc/ckd2-cn.svg)
    &.en
        background-image: url(~public/images/gzzoc/ckd2-en.svg)
.gzzoc-input-number
    ::v-deep
        input::-webkit-outer-spin-button,input::-webkit-inner-spin-button
            -webkit-appearance: none !important
            margin: 0

.form-container
    padding: 20px
    flex: 1 1 auto
    width: 100%
    display: flex
    flex-direction: column
    overflow: auto
    padding-top: 0
    .form-container-left
        width: 80%
        overflow: auto
    .form-container-right
        width: 20%
        overflow: auto
        margin-left: 24px
    .result-form
        ::v-deep
            .el-form-item
                margin-bottom: 6px
                .el-form-item__content
                    display: flex
                    justify-content: start
                    align-items: center
                    .name
                        margin: 0
                        color: #666
                        flex: 1
                    .result
                        color: #333
    .name
        line-height: 1.4
        font-family: PingFangSC-Regular
        font-size: 14px
        color: #666
        margin-bottom: 10px
        white-space: inherit
        overflow: hidden
        text-overflow: ellipsis
        font-weight: bold
    .dec
        line-height: 1.4
        font-family: PingFangSC-Regular
        font-size: 12px
        color: #666
        margin-bottom: 10px
        white-space: inherit
        overflow: hidden
        text-overflow: ellipsis
    .file-content-wrapper
        display: flex
        align-items: center
        margin-top: 10px
        width: 100%
        .upload-button
            flex: 0 0
            margin-top: 0
        .file-name
            flex: 1 1
            margin-left: 16px
            font-size: 14px
            color: #999
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            text-align: left
.right-content-desc
    width: 100%
    text-align: right
    font-size: 12px
    color: #666
    margin-top: 10px
.form-footer
    padding: 20px 20px
    text-align: start
    height: 90px
    display: flex
    gap: 16px
    .submit-btn
        width: 232px
        height: 40px
    .reset-btn
        width: 104px
        height: 40px
        margin-left: 16px
.right-content
    .main
        display: flex
        flex-direction: column
        padding-bottom: 20px
        .item
            flex: 1 1 !important
            &:not(:first-child)
                margin-left: 24px
            .eye
                width: 100%
                display: flex
                align-items: center
                justify-content: center
                margin-top: 24px
                .eye-img
                    width: 300px
                    height: 300px
                    background-color: #fff
                    object-fit: scale-down
                .eye-img:first-child
                    margin-right: 50px
                .name
                    font-family: PingFangSC-Regular
                    font-size: 14px
                    color: #333
                    text-align: center
                    margin-top: 16px
            .result
                padding: 16px 0
                &:not(:last-child)
                    border-bottom: 1px solid #999
                .title
                    font-family: PingFangSC-Semibold
                    font-size: 20px
                    color: #333
                    height: 20px
                    line-height: 20px
                .detail
                    .detail-item
                        display: inline-block
                        line-height: 20px
                        vertical-align: top
                        margin-top: 8px
                        width: 23%
                        margin-right: 2%
                        .item-name
                            font-family: PingFangSC-Regular
                            font-size: 14px
                            color: #666
                        .item-result
                            width: 100%
                            height: 32px
                            display: flex
                            flex-wrap: wrap
                            gap: 8px
                            .item-result-item
                                width: calc(33.3% - 8px)
                                color: #666
                                font-feature-settings: 'clig' off, 'liga' off
                                font-family: "PingFang SC"
                                font-size: 20px
                                font-style: normal
                                font-weight: 600
                                line-height: 32px
                        &.narrow
                            width: 45%
                            margin-right: 5%
                        &.has-big-font
                            &:first-child
                                display: block
                                width: 100%
                                height: auto
                                min-height: 28px
                                line-height: 28px
                                .item-name,
                                .item-result
                                    font-family: PingFangSC-Semibold
                                    font-size: 20px
                                    color: #333
                                    height: auto
                                    min-height: 28px
                                    line-height: 28px
                                    margin-top: 8px
    .footer
        .footer-item
            width: 230px
            position: relative
            left: 100%
            transform: translateX(-100%)
            &:not(:first-child)
                margin-top: 8px
            .name
                font-family: PingFangSC-Regular
                font-size: 14px
                color: #666
                line-height: 20px
                display: inline-block
                height: 20px
            .value
                font-family: PingFangSC-Regular
                font-size: 14px
                color: #333
                line-height: 20px
                display: inline-block
                height: 20px
        .signature
            .sign
                display: inline-block
                width: 154px
                height: 28px
                background: url(~public/images/gzzoc/Visionome.png) no-repeat left top / 154px 28px

.right-tips
    background: none
    padding: 20px 20px 0
    font-size: 12px
    line-height: 1.4
    color: rgba(#fff, .6)
    border-radius: 8px
    .tip-title
        font-family: PingFangSC-Semibold
        font-size: 16px
        line-height: 22px
        color: #333
        letter-spacing: 0.46px
        text-align: justify
        &:not(:first-child)
            margin-top: 16px
    .tip-content
        font-family: PingFangSC-Regular
        font-size: 14px
        line-height: 20px
        color: #333
        letter-spacing: -0.1px
        text-align: justify
        margin-top: 8px
        p
            margin-top: 5px
</style>
